import { render, staticRenderFns } from "./DialogMotivoCancelamento.vue?vue&type=template&id=2fdee273"
import script from "./DialogMotivoCancelamento.vue?vue&type=script&lang=js"
export * from "./DialogMotivoCancelamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports